<app-loader [loading]="loading"></app-loader>
@if (competitor) {
    <div class="flex flex-column gap-3">
        <div class="flex align-items-center gap-2">
            <p-button icon="pi pi-arrow-left"
                      routerLink="/competitor-mappings"
                      [outlined]="true">
            </p-button>
            <span>Back to Competitor Mappings</span>
        </div>
        <h3 class="m-0">{{ (competitor.competitor_mapped || competitor.agency_name) | valueOr }}</h3>
        <div class="flex align-items-center flex-wrap gap-4">
            <span><span class="font-semibold">Raw:</span> {{ competitor.agency_name | valueOr }}</span>
            <span><span class="font-semibold">Type:</span> {{ competitor.agency_type | valueOr }}</span>
            <span class="flex align-items-center gap-2">
                <span class="font-semibold">Exclude:</span>
                <p-tag [rounded]="true"
                       [severity]="competitor.is_excluded ? 'danger' : 'success'">
                    {{ competitor.is_excluded ? 'Yes' : 'No' }}
                </p-tag>
            </span>
            <span class="flex align-items-center gap-2">
                <span class="font-semibold">Tier:</span>
                @if (canEditTier && editingTierMode) {
                    <p-select [options]="tierOptions"
                              [(ngModel)]="editingTierValue"
                              [showClear]="true"
                              optionLabel="label"
                              optionValue="value"
                              placeholder="Select tier"
                              class="w-8rem">
                    </p-select>
                    <p-button icon="pi pi-check"
                              size="small"
                              severity="secondary"
                              [rounded]="true"
                              (onClick)="saveTier()">
                    </p-button>
                    <p-button icon="pi pi-times"
                              size="small"
                              severity="secondary"
                              [rounded]="true"
                              (onClick)="cancelTierEdit()">
                    </p-button>
                } @else {
                    <span>{{ competitor.tier | valueOr }}</span>
                    @if (canEditTier) {
                        <p-button icon="pi pi-pencil"
                                  size="small"
                                  severity="secondary"
                                  [rounded]="true"
                                  (onClick)="openTierEditMode()">
                        </p-button>
                    }
                }
            </span>
        </div>
        <p-tabs [(value)]="activeTab">
            <p-tablist>
                @for (tab of tabs; track tab.label) {
                    <p-tab [value]="tab.label" class="flex align-items-center gap-2 text-inherit">
                        <i [class]="tab.icon"></i>
                        <span>{{ tab.label }}</span>
                    </p-tab>
                }
            </p-tablist>
            <div class="mt-3">
                <app-rate-listing [displayAgencyName]="getDisplayAgencyName()"
                                  [groupBy]="getActiveTab()?.groupBy"
                                  [preset]="getActiveTab()?.preset"
                                  [title]="getActiveTab()?.label">
                </app-rate-listing>
            </div>
        </p-tabs>
    </div>
}
